import countryList from 'react-select-country-list';

let cachedCountryOptions = null;
function getCountryOptions() {
    if (!cachedCountryOptions) {
        cachedCountryOptions = countryList().getData();
    }
    return cachedCountryOptions;
}

function trimIfString(v) {
    return typeof v === 'string' ? v.trim() : v;
}

/**
 * True if a and b are the same string, or both refer to the same ISO 3166-1 entry
 * (e.g. trigger stores "China" from SearchableSelect while conditional_requirements uses "CN").
 */
export function valuesEqualCountryAware(a, b) {
    const aN = trimIfString(a);
    const bN = trimIfString(b);
    if (aN === bN) return true;
    if (aN == null || bN == null || aN === '' || bN === '') return false;
    const options = getCountryOptions();
    const optA = options.find((o) => o.label === aN || o.value === aN);
    const optB = options.find((o) => o.label === bN || o.value === bN);
    return !!(optA && optB && optA.value === optB.value);
}

/** Alias for conditional-requirement switches (same behaviour as valuesEqualCountryAware). */
export const valuesEqualForConditionalRequirement = valuesEqualCountryAware;

/**
 * Postgres JSONB is usually an object; some pipelines store JSON as text — normalize for client logic.
 */
export function normalizeConditionalRequirements(raw) {
    if (raw == null || raw === '') return null;
    if (typeof raw === 'object' && !Array.isArray(raw)) return raw;
    if (typeof raw === 'string') {
        try {
            const parsed = JSON.parse(raw);
            return typeof parsed === 'object' && parsed !== null ? parsed : null;
        } catch {
            return null;
        }
    }
    return null;
}
